import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@context/AuthContext';


const ProtectedRoute = () => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return null;
    }

    if (!isAuthenticated) {
        const isStudent = window.location.pathname.startsWith('/student');
        return <Navigate to={isStudent ? '/login' : '/admin/signin'} replace />;
    }

    return <Outlet />;
}

export default ProtectedRoute;